import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import "../includes/react-quill-custom-stylesheet.css"
import { Redirect } from 'react-router-dom';
import Select from 'react-select';
import { setCookie, getCookie } from '../common_component/cookie.js';
import { useTheme } from "./theme-provider.js";
import { useAuthData } from "./auth-provider.js";
import PageError from '../common_component/PageError.js';

function SetUpEcommerceContentInfo() {
	const [state, setstate] = useState(2);
	const { theme, dropdownStyleDark } = useTheme();
	const [richTextContext, setRichTextContext] = useState("");

	const [SequenceSelectionList, setSequenceSelectionList] = useState([]);
	const [questionAnswerContextOrder, setQuestionAnswerContextOrder] = useState(1);
	const [richTextContextOrder, setRichTextContextOrder] = useState(2);

	const [contentId, setContentId] = useState("");
	const [subdomainName, setSubdomainName] = useState("");
	const [contentList, setContentList] = useState([]);
	const [contentFlag, setContentFlag] = useState(false);

	const [contentType, setContentType] = useState([]);
	const [questionAnswerContext, setQuestionAnswerContext] = useState([]);
	const [contentName, setContentName] = useState(null);

	const [mainSubmitButtonState, setMainSubmitButtonState] = useState(false)

	var page_name = "set-up-ecommerce-content-info";

	const { user, read, write, visibility, organization_id } = useAuthData(page_name);

	const loaderstyle = {
		display: "block",
		marginLeft: "auto",
		marginRight: "auto",
		marginTop: "auto",
		marginBottom: "auto",
	};

	const contentNameList = ["About Us", "Faq", "Terms", "Privacy", "Refund Policy"];
	const contentTypeList = ["Rich Text Context", "Qusetion Answer"].map(x => ({ label: x, value: x }));

	const quill_rte_modules = {
		toolbar: [
			[{ 'font': [] }, { 'size': [] }],
			['bold', 'italic', 'underline', 'strike'],
			[{ 'color': [] }, { 'background': [] }],
			[{ 'script': 'super' }, { 'script': 'sub' }],
			[{ 'header': '1' }, { 'header': '2' }, 'blockquote', 'code-block'],
			[{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
			['direction', { 'align': [] }],
			['link', 'image', 'video', 'formula'],
			['clean']
		],
	}
	const quill_rte_formats = ["header", "font", "size", "bold", "italic", "underline", "align", "strike", "script", "blockquote", "background", "list", "bullet", "indent", "link", "image", "color", "code-block"]

	useEffect(() => {
		async function getEcommercedetails() {
			var object = {};
			object.email = user.email;

			const response = await fetch(
				`${process.env.REACT_APP_SERVER_URL}/get-ecommerce-content-info`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
			);
			const body = await response.json();
			if (body.operation === "success") {
				setstate(1);
				setSubdomainName(body.subdomain_name);
				if (body.data.length > 0) {
					setContentId(body.data[0].unique_id);
					setContentList(body.data[0].content_list);
					setContentFlag(true);
				}
			}
		}
		if (read || write) {
			(user.email && visibility) && getEcommercedetails();
		}
	}, [user, visibility, read, write])

	const updateSetupInfo = () => {
		// var id = user.email;

		if (contentName === "") {
			swal("Oops!", "You need to select a content name", "warning");
			return false;
		}
		if (contentType.length === 0) {
			swal("Oops!", "Content type can't be empty", "warning");
			return false;
		}
		if (richTextContextOrder === questionAnswerContextOrder) {
			swal("Oops!", "order number can't be same!", "warning");
			return false;
		}

		var values = { "content_id": contentId, "content_name": contentName.value, "question_answer_context_order": questionAnswerContextOrder, "rich_text_order": richTextContextOrder, "content_type": contentType, "rich_text_context": richTextContext, "question_answer_context": questionAnswerContext, "page_name": page_name, "organization_id": organization_id };
		setMainSubmitButtonState(true)
		var headers = {
			headers: {
				"Content-Type": "application/json",
				"Accept": "*/*",
				"token": getCookie("access_token")
			}
		}
		let api = `add-ecommerce-content-info`;
		if (contentFlag) {
			api = `update-ecommerce-content-info`;
		}
		axios.post(`${process.env.REACT_APP_SERVER_URL}/${api}`, values, headers).then((res) => {
			setMainSubmitButtonState(false)
			if (res.data && res.data.operation === "success") {
				swal("Great!", `Ecommerce content saved successfully!`, "success").then((value) => {
					window.location.reload();
				});
			}
			else if (res.data.operation === "no_modification") {
				setMainSubmitButtonState(false)
				swal("Oops!", "You need to modify something for updation!!", "error");
			}
			// else  if(res.data.operation === "danger" && res.data.message === "same_subdomain_name")
			// {
			// 	swal("Oops!", "Same subdomain already present for ecommerce!", "warning");
			// }
			// else  if(res.data.operation === "danger" && res.data.message === "same_tenant_name")
			// {
			// 	swal("Oops!", "Same tenant name already present for ecommerce!", "warning");
			// }
			// else  if(res.data.operation === "danger" && res.data.message === "same_application_name")
			// {
			// 	swal("Oops!", "Same application name already present for ecommerce!", "warning");
			// }
			else {
				swal("Oops!", "Something went wrong!", "error");
			}
		});
	}

	const LoadContentData = (val) => {
		let data = contentList.filter(option => option.content_name === val);
		console.log("data", data);
		if (data.length > 0) {
			setContentType(data[0].content_type);
			setRichTextContext(data[0].rich_text_context);
			setQuestionAnswerContext(data[0].question_answer_context);
			if (data[0].content_type.length === 2) {
				setSequenceSelectionList([{ label: 1, value: 1 }, { label: 2, value: 2 }]);
			}
			else {
				setSequenceSelectionList([{ label: 1, value: 1 }]);
			}
		}
		else {
			setContentType([]);
			setRichTextContext("");
			setQuestionAnswerContext([]);
		}
	}

	return (
		<>
			<div>
				<div className="d-flex flex-stack mb-5">
					<h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Ecommerce content information</h1>
				</div>
				<div>
					{state === 1 ?
						<>
							<div className="card my-2">
								<div className="card-header">
									<div className='card-title fw-bold'>Short Details</div>

								</div>
								<div className="card-body">
									<div className="row mb-5">
										<div className="col-md-6">
											<label className="fs-5 fw-bold mb-2">Content Name</label>
											<Select
												styles={theme === 'dark' ? dropdownStyleDark : {}}
												options={contentNameList.map(x => { return { label: x, value: x } })}
												onChange={(val) => {
													if (contentFlag) {
														LoadContentData(val.value);
													}
													else {
														setContentType([]);
														setRichTextContext("");
														setQuestionAnswerContext([]);
													}
													setContentName(val)
												}}
												value={contentName}
												isClearable
											/>
										</div>
										<div className="col-md-6">
											<label className="fs-5 fw-bold mb-2">Content List</label>
											<Select
												isMulti
												styles={theme === 'dark' ? dropdownStyleDark : {}}
												options={contentTypeList}
												onChange={(val) => {
													if (val.length === 2) {
														setSequenceSelectionList([{ label: 1, value: 1 }, { label: 2, value: 2 }]);
													}
													else {
														setSequenceSelectionList([{ label: 1, value: 1 }]);
													}
													setRichTextContextOrder("");
													setQuestionAnswerContextOrder("");
													setContentType(val)
												}}
												value={contentType}
												isClearable
											/>
										</div>
									</div>
									{
										contentName !== null &&
										<div class="col-xl-6">
											<h4 class="fs-5 fw-bold mb-2">
												Page Link
											</h4>
											{/* <a href={contentName.value === "About Us" ? `${subdomainName}/about-us` : contentName.value === "Faq" ? `${subdomainName}/faq` : contentName.value === "Terms" ? `${subdomainName}/terms` : `${subdomainName}/privacy`} target="_blank"> */}
											<button
												onClick={() => {
													let t = contentName.value === "About Us" ? `${subdomainName}/about-us` : contentName.value === "Faq" ? `${subdomainName}/faq` : contentName.value === "Terms" ? `${subdomainName}/terms` : contentName.value === "Privacy" ? `${subdomainName}/privacy` : `${subdomainName}/refund-policy`
													window.open(t)
												}}
												class="btn btn-light btn-active-light-primary fw-bold flex-shrink-0 mt-4">
												{subdomainName}{contentName.value === "About Us" ? "/about-us" : contentName.value === "Faq" ? "/faq" : contentName.value === "Terms" ? "/terms" : contentName.value === "Privacy" ? "/privacy" : `${subdomainName}/refund-policy`}
											</button>
											{/* </a> */}
										</div>
									}
								</div>
							</div>
							{(contentType !== null && contentType.filter(option => option.label === "Rich Text Context").length > 0) &&
								<div className="card my-2">
									<div className="card-header">
										<div className='card-title fw-bold'>Rich Text Context</div>
										<div className='card-toolbar'>
											<Select
												styles={theme === 'dark' ? dropdownStyleDark : {}}
												options={SequenceSelectionList}
												onChange={(val) => {
													// if(val.value===questionAnswerContextOrder)
													// {
													// 	swal("Oops!", "This order number already exist!", "warning");
													// }
													// else
													// {
													// 	setRichTextContextOrder(val.value);
													// } 
													setRichTextContextOrder(val.value);
												}}
												value={{ label: richTextContextOrder, value: richTextContextOrder }}
												placeholder="Select the Sequence of Order"
											/>
										</div>
									</div>
									<div className="card-body">
										<ReactQuill
											theme="snow"
											modules={quill_rte_modules}
											formats={quill_rte_formats}
											value={richTextContext}
											onChange={(val) => { setRichTextContext(val) }}
										/>
									</div>
								</div>}
							{(contentType !== null && contentType.filter(option => option.label === "Qusetion Answer").length > 0) &&
								<div className="card card-flush py-4">
									<div className="card-header">
										<div className='card-title fw-bold'>Qusetion Answer Context</div>
										<div className='card-toolbar'>
											<Select
												styles={theme === 'dark' ? dropdownStyleDark : {}}
												options={SequenceSelectionList}
												onChange={(val) => {
													setQuestionAnswerContextOrder(val.value);
													// if(richTextContextOrder===val.value)
													// {
													// 	swal("Oops!", "This order number already exist!", "warning");
													// }
													// else
													// {
													// 	setQuestionAnswerContextOrder(val.value);
													// }  
												}}
												value={{ label: questionAnswerContextOrder, value: questionAnswerContextOrder }}
												placeholder="Select the Sequence of Order"
											/>
										</div>
									</div>
									<div className="card-body">
										<div className='container p-0'>
											{questionAnswerContext.length > 0 &&
												<div className="row gx-0">
													<div className="col-md-6 px-3">
														<h4>Question </h4>
													</div>
													<div className="col-md-4 px-3 justify-content-start">
														<h4>Answer</h4>
													</div>
												</div>}
											{
												questionAnswerContext.length === 0 ? <div className='text-center'><div className='text-gray-600 fs-2'>No Context added</div></div> :
													<>
														{questionAnswerContext.map((obj, i) => {
															return (
																<div key={i} className="row gx-0 my-2">
																	<div className="col-md-4 px-3">
																		<label className="form-label"></label>
																		<textarea className="form-control form-control-solid m-1" placeholder="Enter an Question..." value={obj.question}
																			onChange={(e) => {
																				let t = questionAnswerContext.map(x => { return { ...x } })
																				t[i].question = e.target.value
																				setQuestionAnswerContext(t)
																			}}
																		/>
																		{/* <div className="text-muted fs-7">Tap the button to make an item the primary one.</div> */}
																	</div>
																	<div className="col-md-7 px-3">
																		<label className="form-label"></label>
																		<textarea className="form-control form-control-solid m-1" placeholder="Enter Answer..." value={obj.answer}
																			onChange={(e) => {
																				let t = questionAnswerContext.map(x => { return { ...x } })
																				t[i].answer = e.target.value
																				setQuestionAnswerContext(t)
																			}}
																		/>
																		{/* <div className="text-muted fs-7">Tap the button to make an item the primary one.</div> */}
																	</div>
																	<div className="col-md-1 px-3">
																		<button className="btn btn-outline-danger text-hover-danger rounded-pill mt-6" onClick={() => {
																			let t = questionAnswerContext.map(x => { return { ...x } })
																			t.splice(i, 1);
																			setQuestionAnswerContext(t);
																		}}><i className="bi bi-trash"></i>
																		</button>
																	</div>
																</div>
															)
														})}

													</>
											}
											<button className='btn btn-primary'
												onClick={() => {
													let t = questionAnswerContext.map(x => { return { ...x } })
													t.push({ question: "", answer: "" })
													setQuestionAnswerContext(t)
												}}>+ Add Context
											</button>
											{/* <button className='btn btn-link text-hover-success' onClick={() => { setQuestionAnswerContext([...questionAnswerContext, { heading: "", attribute_list: [] }]) }}>+ Add Heading</button> */}
										</div>
									</div>
								</div>
							}
							{
								(write && contentType !== null) &&
								<div className="d-flex justify-content-end mt-2">
									<button type="button" className="btn btn-primary rounded" onClick={updateSetupInfo} data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState}><span className="indicator-label">{contentFlag ? <>Update</> : <>Save</>} Changes</span>
										<span className="indicator-progress">Please wait...
											<span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
								</div>

							}
						</>
						:
						<div className="card modal-body pt-0 pb-15 px-5 px-xl-20">
							<br />

							{state === 2 ?
								<img src="/images/loader-06.svg" alt="" style={loaderstyle} />
								:
								<PageError />
							}
							<br />
						</div>
					}
				</div>
			</div>
		</>
	);
}
export default SetUpEcommerceContentInfo;